import { useCallback, useEffect, useState } from 'react';

// One-shot async fetch with loading / error state.
//
// const { data, loading, error, refresh } = useApi(api.getDashboard, []);
//
// Pass deps to refetch when they change.
export function useApi(fetchFn, deps = []) {
  const [data, setData]       = useState(null);
  const [error, setError]     = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await fetchFn());
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { refresh(); }, [refresh]);

  return { data, loading, error, refresh };
}
